import { useDetailPageStore } from "@/stores/DetailPage";
import { storeToRefs } from 'pinia';
import { usePlayerStore } from "@/stores/Player";
import { useHomePageStore } from "@/stores/HomePage";

const DetailPageStoreModule = useDetailPageStore();
const {
	getCurrentItemDetail: currentItem,
} = storeToRefs(DetailPageStoreModule);

const PlayerStoreModule = usePlayerStore();
const {
	fetchRelatedContent,
} = PlayerStoreModule;

const {clearHomeTimers} = useHomePageStore();

export default defineNuxtRouteMiddleware(() => {
	if (import.meta.client) {
		void fetchRelatedContent(currentItem.value);

		clearHomeTimers()
	}
});